import React, { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Papa from "papaparse";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Registration from "./Registration";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../index.css";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  dealerSelected,
  IncrementCamera,
  DecrementCamera,
  IncrementCameraByFive,
  IncrementCameraByTen,
  deleteCameraByTen,
  IncrementOptions,
  DecrementOptions,
  setAPIDATA,
  setTemplateOptionsData,
  totalSelectedOptions,
  deleteSpecial,
  setTotalCamera,
  optionSelected,
  replaceImportedCart,
  setImportedQuoteState,
  setCustomerData,
  setOptionHeading,
  setOptionDisplayText,
  setOptionDescription,
  setQuoteVersion,
  clearQuoteData,
} from "../../app/features/counter/counterSlice";

import { CategoryCsvData } from "../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import { toast } from 'react-toastify';
import { VERSION, LEGACY_VERSION_LABEL, getVersionWarningMessage, isVersionMismatch } from "../../config/Version";
import { refreshImportedCartPricing, buildImportPricingChangeMessage, reviewImportPricingChanges } from "./importPriceRefresh";

function Home() {
  const countCamera = useSelector((state) => state.counter1);
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);
  const tempateData = useSelector(
    (state) => state.counter1.templateOptionsData
  );
  const totalOptions = useSelector((state) => state.counter1.totalOptions);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showTemp, setShowTemp] = useState(false);
  const [showCam_num, setShowCam_num] = useState(false);
  const [categories, setCategories] = useState([]);
  const customerUserData = useSelector((state) => state.counter1.customerData);
  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const whichOption = useSelector((state) => state.counter1.whichOptionSelected || "1");
  const importQuoteInputRef = useRef(null);
  const [quoteStartMode, setQuoteStartMode] = useState("build");
  const [pendingQuoteStartMode, setPendingQuoteStartMode] = useState(null);
  const [showClearQuoteModal, setShowClearQuoteModal] = useState(false);
  const selectedNVR = useSelector((state) => state.counter1.selectedNVR || []);
  const selectedCamera = useSelector((state) => state.counter1.selectedCamera || []);
  const selectedCabling = useSelector((state) => state.counter1.selectedCabling || []);
  const selectedLabor = useSelector((state) => state.counter1.selectedLabor || []);
  const selectedPoE = useSelector((state) => state.counter1.selectedPoE || []);
  const selectedHardWare = useSelector((state) => state.counter1.selectedHardWare || []);
  const selectedSpecial = useSelector((state) => state.counter1.selectedSpecial || []);

  const hasExistingQuoteData = () => {
    return (
      totalNoOptions !== undefined ||
      Number(countCamera.totalCamera || 0) > 0 ||
      Number(countCamera.totalOptions || 0) > 0 ||
      selectedNVR.length > 0 ||
      selectedCamera.length > 0 ||
      selectedCabling.length > 0 ||
      selectedLabor.length > 0 ||
      selectedPoE.length > 0 ||
      selectedHardWare.length > 0 ||
      selectedSpecial.length > 0
    );
  };

  let categoriesData = [];
  let productOptionsDetails = [];

  // Formik Validation
  const validationSchema = Yup.object().shape({
    building_A_Name: Yup.string().required("Building-1 Name is required"),
    building_A_CameraNumber: Yup.number().required(
      "Building-1 Number is required"
    ),
    building_B_Name: Yup.string().required("Building-2 Name is required"),
    building_B_CameraNumber: Yup.number().required(
      "Building-2 Number is required"
    ),
  });

  // Formik Code
  const formik = useFormik({
    initialValues: {
      building_A_Name: "",
      building_A_CameraNumber: "",
      building_B_Name: "",
      building_B_CameraNumber: "",
    },
    validationSchema,
    onSubmit: (values) => {

      dispatch(setTemplateOptionsData(values));
    },
  });

  const handleOptionsIncre = () => {
    dispatch(IncrementOptions());
  };

  const handleOptionsDecre = () => {
    if (countCamera.totalOptions > 0) {
      dispatch(DecrementOptions());
    }
  };
  // Storing value of + and - button in state (No. of Camera)

  const handleCameraIncre = () => {
    dispatch(IncrementCamera());
  };

  const handleCameraDecre = () => {
    if (countCamera.totalCamera > 0) {
      dispatch(DecrementCamera());
    }
  };

  // Incrase by +5

  const handleCameraIncreByFive = () => {
    dispatch(IncrementCameraByFive());
  };

  const handleCameraIncreByTen = () => {
    dispatch(IncrementCameraByTen());
  };

  const deleteCameraIncreByTen = () => {
    dispatch(deleteCameraByTen());
  };

  const quoteStartOptions = [
    {
      key: "build",
      title: "Build a Quote",
      description: "Start a standard customer quote using regular product visibility and pricing.",
      button: "Build Quote",
      variant: "dark",
    },
    {
      key: "dealer",
      title: "Dealer Quote",
      description: "Start a dealer quote using dealer product visibility and dealer pricing.",
      button: "Dealer Quote",
      variant: "dark",
    },
    {
      key: "service",
      title: "Service Call",
      description: "Create a one-option service quote with no cameras and go directly to Labor.",
      button: "Service Call",
      variant: "dark",
    },
    {
      key: "import",
      title: "Import Quote",
      description: "Import a saved quote CSV and open it directly in the cart.",
      button: "Import Quote",
      variant: "dark",
    },
  ];

  React.useEffect(() => {
    const parseCSVFiles = async () => {
      try {
        const csvBase = `${process.env.PUBLIC_URL}/assets/CSVs`;

		const categoryData = await fetch(`${csvBase}/categories.csv`);
		const productData = await fetch(`${csvBase}/products.csv`);
		const productOptionData = await fetch(`${csvBase}/product_options.csv`);
		
        const categoryArray = await categoryData.text();
        const productArray = await productData.text();
        const productOptionArray = await productOptionData.text();
        const categories2 = Papa.parse(productArray, { header: true }).data;
        setCategories(categories2);
        dispatch(setAPIDATA(categories2));

        categories.map(
          ({
            id,
            category_name,
            category_description,
            category_parent,
            iconimage,
            filename,
            sorting,
          }) => {
            categoriesData.push({
              id,
              category_name,
              category_description,
              category_parent,
              iconimage,
              filename,
              sorting,
            });
          }
        );
        const products = Papa.parse(productArray, { header: true }).data;
        const productOptions = Papa.parse(productOptionArray, {
          header: true,
        }).data;
        productOptions.map(
          ({
            optionid,
            productid,
            featurecaption,
            featuretype,
            featureprice,
            partnumber,
            selected,
            sorting,
            thumbpath,
            featurerequired,
          }) => {
            productOptionsDetails.push({
              optionid,
              productid,
              featurecaption,
              featuretype,
              featureprice,
              partnumber,
              selected,
              sorting,
              thumbpath,
              featurerequired,
            });
          }
        );

        setData((data) => ({
          categories: categoriesData,
          products,
          productOptions: productOptionsDetails,
        }));
      } catch (error) {
        console.error("Error parsing CSV files:", error);
      }
    };
    parseCSVFiles();
  }, []);

  const fetchInfo = () => {
    return axios
      .get(`${process.env.PUBLIC_URL}/assets/CSVs/products.csv`)
      .then((response) => setData(response.data));
  };
  React.useEffect(() => {
    fetchInfo();
  }, []);

  const beginQuoteFlow = (mode) => {
    setQuoteStartMode(mode);

    try {
      localStorage.removeItem("productAdded");
      localStorage.setItem("autoSpecialDefaultsEnabled", mode === "build" ? "1" : "0");
    } catch (error) {
      // ignore storage errors
    }

    if (mode === "import") {
      importQuoteInputRef.current?.click();
      return;
    }

    if (mode === "service") {
      dispatch(dealerSelected("Non Dealer Selected"));
      dispatch(totalSelectedOptions(1));
      dispatch(optionSelected("1"));
      dispatch(setTotalCamera(0));
      navigate("/labor");
      return;
    }

    if (mode === "dealer") {
      dispatch(dealerSelected("Dealer Selected"));
    } else {
      dispatch(dealerSelected("Non Dealer Selected"));
    }

    setShow(true);
  };

  const startQuoteFlow = (mode) => {
    if (mode === "import") {
      beginQuoteFlow(mode);
      return;
    }

    if (hasExistingQuoteData()) {
      setPendingQuoteStartMode(mode);
      setShowClearQuoteModal(true);
      return;
    }

    beginQuoteFlow(mode);
  };

  const handleClearQuoteAndContinue = () => {
    const mode = pendingQuoteStartMode || "build";
    try {
      localStorage.removeItem("productAdded");
      localStorage.setItem("autoSpecialDefaultsEnabled", mode === "build" ? "1" : "0");
    } catch (error) {
      // ignore storage errors
    }
    dispatch(clearQuoteData());
    setShowClearQuoteModal(false);
    setPendingQuoteStartMode(null);
    beginQuoteFlow(mode);
  };

  const handleOptions = (e) => {
    startQuoteFlow(e.target.value);
  };

  const handleClick = () => {
    setShow(false);
    setShowCam_num(true);
  };

  const applyInitialOptionTextDefaults = (optionCount) => {
    const count = Number(optionCount || 0);

    if (count < 2) return;

    const defaultOptionText = {
      1: {
        displayText: "OPTION 1 - BEST VALUE",
        heading: "2K Resolution Cameras - with AI VCA",
      },
      2: {
        displayText: "OPTION 2 - BEST RESOLUTION",
        heading: "4K Resolution Cameras - with AI VCA",
      },
      3: {
        displayText: "OPTION 3 - Lower Cost",
        heading: "1080P Resolution Cameras",
      },
    };

    Object.entries(defaultOptionText).forEach(([option, defaults]) => {
      if (Number(option) <= count) {
        dispatch(setOptionDisplayText({ whichOption: option, text: defaults.displayText }));
        dispatch(setOptionHeading({ whichOption: option, text: defaults.heading }));
      }
    });
  };

  const handleNext = () => {
    navigate("/nvr");
    if (totalOptions !== 0) {
      dispatch(totalSelectedOptions(totalOptions));
      dispatch(optionSelected("1"));
      applyInitialOptionTextDefaults(totalOptions);
    } else {
      dispatch(totalSelectedOptions(undefined));
    }
  };

  const getImportBucket = (item, row = {}) => {
    const validBuckets = [
      "selectedCamera",
      "selectedCabling",
      "selectedLabor",
      "selectedNVR",
      "selectedPoE",
      "selectedHardWare",
      "selectedSpecial",
    ];

    if (row.cart_bucket && validBuckets.includes(row.cart_bucket)) {
      return row.cart_bucket;
    }

    if (item?.cart_bucket && validBuckets.includes(item.cart_bucket)) {
      return item.cart_bucket;
    }

    if (item?.category === "DVRs & NVRs/NVR Recorders (IP Cameras)" || item?.NVR_Name || item?.nvrName || item?.NVR_Quantity) {
      return "selectedNVR";
    }
    if (item?.category === "Camera" || item?.Camera_Quantity) return "selectedCamera";
    if (item?.category === "Cabling" || item?.cableColor || item?.["Cable Color"]) return "selectedCabling";
    if (item?.category === "Labor" || item?.extra_field_4 !== undefined) return "selectedLabor";
    if (item?.category === "Poe" || item?.Port_Name || item?.Port_Quantity) return "selectedPoE";
    if (item?.category === "Hardware" || item?.Hardware_Total_data || item?.HardWare_Base_Price || item?.Hardware_New_Final_Price) return "selectedHardWare";

    return "selectedSpecial";
  };

  const buildImportedItemFromRow = (row) => {
    const quantity = Number(row.quantity || row.Product_Quantity || row.Quantity || 1);
    const unitPrice = Number(row.unit_price || row.Product_Base_Price || row["Base Price"] || 0);
    const optionUnitCost = Number(row.option_unit_cost || 0);
    const lineTotal = Number(row.line_total || row.Product_Final_Price || row["Final Price"] || 0);
    const optionNumber = row.num_options || row.option || whichOption || "1";

    const item = {
      uniqueID: row.uniqueID || Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
      num_options: optionNumber,
      option: optionNumber,
      id: row.sku || row.Product_Name || row["Product Name"],
      Product_Name: row.sku || row.Product_Name || row["Product Name"],
      name: row.name || row.Name || row["Product Name"],
      Name: row.name || row.Name || row["Product Name"],
      quantity,
      Product_Quantity: quantity,
      pricePerItem: unitPrice,
      Product_Base_Price: unitPrice,
      totalPriceForItem: unitPrice + optionUnitCost,
      Product_Final_Price: lineTotal || (unitPrice + optionUnitCost) * quantity,
    };

    for (let i = 1; i <= 12; i += 1) {
      const optionName = row[`option${i}_name`];
      if (optionName) {
        item[optionName] = row[`option${i}_value`];
        item[`${optionName}_price`] = Number(row[`option${i}_price`] || 0);
      }
    }

    return item;
  };

  const normalizeImportedCartItem = (item, bucket, row = {}) => {
    const optionNumber = item.num_options || item.option || row.num_options || whichOption || "1";
    const { cart_bucket, raw_item_json, options_json, globalOption, ...cleanItem } = item || {};

    return {
      ...cleanItem,
      uniqueID: cleanItem.uniqueID || row.uniqueID || Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
      num_options: optionNumber,
      option: optionNumber,
    };
  };

  const safelyParseJson = (value, fallback) => {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  const getLineSignature = (item = {}) => [
    item.num_options || item.option || "",
    item.Product_Name || item.id || item.Port_Name || "",
    item.Name || item.name || item.Product_Description || "",
    item.Product_Quantity || item.Camera_Quantity || item.Port_Quantity || item.quantity || "",
    item.Product_Final_Price || item.Camera_Final_Price || item.poeFinalPrice || item.totalPriceForItem || "",
  ].join("::");

  const dedupeSpecialItems = (items = []) => {
    const seen = new Set();
    return items.filter((item) => {
      const signature = getLineSignature(item);
      if (seen.has(signature)) return false;
      seen.add(signature);
      return true;
    });
  };

  const sanitizeCartSnapshot = (snapshot = {}) => ({
    ...snapshot,
    selectedSpecial: dedupeSpecialItems(snapshot.selectedSpecial || []),
  });

  const importQuoteCsv = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const imported = {
          selectedCamera: [],
          selectedCabling: [],
          selectedLabor: [],
          selectedNVR: [],
          selectedPoE: [],
          selectedHardWare: [],
          selectedSpecial: [],
        };

        let importedTotalOptions = null;
        let importedCustomerData = null;
        let importedOptionHeading = null;
        let importedOptionDisplayText = null;
        let importedOptionDescription = null;
        let importedOptionDiscounts = null;
        let importedCartSnapshot = null;
        let importedQuoteVersion = null;
        let importedQuoteState = {};

        (results.data || []).forEach((row) => {
          if (row.row_type === "quote_metadata") {
            importedQuoteVersion = row.quote_version || row.app_version || row.exported_with_version || null;
            importedTotalOptions = Number(row.total_no_options || 0) || null;
            importedCustomerData = safelyParseJson(row.customer_data_json, null);
            importedOptionHeading = safelyParseJson(row.option_heading_json, null);
            importedOptionDisplayText = safelyParseJson(row.option_display_text_json, null);
            importedOptionDescription = safelyParseJson(row.option_description_json, null);
            importedOptionDiscounts = safelyParseJson(row.option_discounts_json, null);
            importedCartSnapshot = safelyParseJson(row.cart_snapshot_json, null);
            importedQuoteState = {
              quoteVersion: importedQuoteVersion || LEGACY_VERSION_LABEL,
              totalCamera: Number(row.total_camera || 0),
              selectedDrops: safelyParseJson(row.selected_drops_json, {}),
              selectedCameraQuantity: safelyParseJson(row.selected_camera_quantity_json, {}),
              comparisonData: safelyParseJson(row.comparison_data_json, {}),
              optionDiscounts: importedOptionDiscounts || {},
            };
            return;
          }

          let item = null;
          if (row.raw_item_json) {
            try {
              item = JSON.parse(row.raw_item_json);
            } catch (error) {
              item = null;
            }
          }

          if (!item) item = buildImportedItemFromRow(row);

          const bucket = getImportBucket(item, row);
          if (!imported[bucket]) imported[bucket] = [];
          imported[bucket].push(normalizeImportedCartItem(item, bucket, row));
        });

        const safeImportedQuoteVersion = importedQuoteVersion || LEGACY_VERSION_LABEL;

        if (isVersionMismatch(safeImportedQuoteVersion, VERSION)) {
          window.alert(getVersionWarningMessage(safeImportedQuoteVersion, VERSION));
        }

        if (importedTotalOptions) dispatch(totalSelectedOptions(importedTotalOptions));
        dispatch(setImportedQuoteState({
          ...importedQuoteState,
          quoteVersion: safeImportedQuoteVersion,
        }));
        dispatch(setQuoteVersion(safeImportedQuoteVersion));
        if (importedCustomerData) dispatch(setCustomerData(importedCustomerData));

        if (importedOptionHeading) {
          Object.entries(importedOptionHeading).forEach(([option, text]) => {
            dispatch(setOptionHeading({ whichOption: option, text }));
          });
        }

        if (importedOptionDisplayText) {
          Object.entries(importedOptionDisplayText).forEach(([option, text]) => {
            dispatch(setOptionDisplayText({ whichOption: option, text }));
          });
        }

        if (importedOptionDescription) {
          Object.entries(importedOptionDescription).forEach(([option, text]) => {
            dispatch(setOptionDescription({ whichOption: option, text }));
          });
        }

        if (importedCartSnapshot) {
          const cleanSnapshot = sanitizeCartSnapshot(importedCartSnapshot);
          const pricingRefresh = refreshImportedCartPricing(cleanSnapshot, productCSVQuery, productOptionCSVQuery, areYouDealer);
          const reviewedPricing = await reviewImportPricingChanges(pricingRefresh);
          const refreshedSnapshot = reviewedPricing.cartData;
          dispatch(
            replaceImportedCart({
              selectedCamera: refreshedSnapshot.selectedCamera || [],
              selectedCabling: refreshedSnapshot.selectedCabling || [],
              selectedLabor: refreshedSnapshot.selectedLabor || [],
              selectedNVR: refreshedSnapshot.selectedNVR || [],
              selectedPoE: refreshedSnapshot.selectedPoE || [],
              selectedHardWare: refreshedSnapshot.selectedHardWare || [],
              selectedSpecial: refreshedSnapshot.selectedSpecial || [],
            })
          );
        } else {
          const importedCart = {
            ...imported,
            selectedSpecial: dedupeSpecialItems(imported.selectedSpecial || []),
          };
          const pricingRefresh = refreshImportedCartPricing(importedCart, productCSVQuery, productOptionCSVQuery, areYouDealer);
          const reviewedPricing = await reviewImportPricingChanges(pricingRefresh);
          dispatch(replaceImportedCart(reviewedPricing.cartData));
        }

        try {
          localStorage.removeItem("productAdded");
          localStorage.setItem("autoSpecialDefaultsEnabled", "0");
        } catch (error) {
          // ignore storage errors
        }

        event.target.value = "";
        navigate("/cart");
      },
      error: () => {
        toast.error("Unable to import quote CSV.");
        event.target.value = "";
      },
    });
  };

  // UniverSal Data Starts
  const { categoryCSVQuery, isLoading1, isOnline, isError1 } =
    CategoryCsvData();
  const { productCSVQuery, isLoading2, isOnline2, isError2 } = ProductCsvData();
  const { productOptionCSVQuery, isLoading3, isOnline3, isError3 } =
    ProductOptionsCsvData();

  if (!isOnline && !categoryCSVQuery) {
    return <p>No internet connection. Check your network settings.</p>;
  }

  if (isLoading1) {
    return <p>Loading...</p>;
  }

  if (isError1) {
    return <p>Error fetching data.</p>;
  }

  // Universal Data Ends

  // Template Click Yes
  const templateClickYes = () => {
    setShow2(true); // Modal Opens
    setShowTemp(false);
  };

  const handleClose = () => {
    setShow2(false);
    navigate("/templatea");
  };

  return (
    <>
      {/* {Array.isArray(customerUserData) && customerUserData.length === 0 ? <Registration /> : null} */}
      <Container className="my-4" >
        <Row className="p-1">
          {/* Left */}
          <Col className="marginTopSpace">
            <Row className="my-4">
              {quoteStartOptions.map((details) => (
                <Col md={3} sm={6} className="my-3" key={details.key}>
                  <Card className="card-hover h-100">
                    <Card.Body className="d-flex flex-column">
                      <Card.Title>{details.title}</Card.Title>
                      <Card.Text className="flex-grow-1">
                        {details.description}
                      </Card.Text>
                      <Button
                        variant={details.variant}
                        value={details.key}
                        onClick={handleOptions}
                      >
                        {details.button}
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            <input
              ref={importQuoteInputRef}
              type="file"
              accept=".csv"
              style={{ display: "none" }}
              onChange={importQuoteCsv}
            />
          </Col>
        </Row>
        <Modal show={showClearQuoteModal} onHide={() => setShowClearQuoteModal(false)} backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>Clear Current Quote?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            There is already quote data in the cart. Starting a new quote will clear the current quote first.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowClearQuoteModal(false)}>
              Cancel
            </Button>
            <Button variant="dark" onClick={handleClearQuoteAndContinue}>
              Clear Cart and Continue
            </Button>
          </Modal.Footer>
        </Modal>

        {/*Options Modal*/}
        <Modal show={show} onHide={() => setShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{quoteStartMode === "dealer" ? "Dealer Quote Options" : "Quote Options"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="my-2">
              <Col md={8} >
                Number of Options
              </Col>
              <Col md={4} >
                <div
                  className="d-flex align-items-end justify-content-end"

                >
                  <Button variant="dark" onClick={handleOptionsIncre}>
                    +
                  </Button>
                  <h6 className="mx-3">{countCamera.totalOptions}</h6>
                  <Button variant="dark" onClick={handleOptionsDecre}>
                    -
                  </Button>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button className="d-block" variant="dark" onClick={handleClick}>
              Next
            </Button>
          </Modal.Footer>
        </Modal>
        {/*Template Modal*/}
        <Modal show={showTemp} onHide={() => setShowTemp(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Use Templates</Modal.Title>
          </Modal.Header>
          <Modal.Body>Use Templates?</Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={templateClickYes}>
              Yes
            </Button>
            <Button variant="dark" onClick={() => setShowCam_num(true)}>
              No
            </Button>
          </Modal.Footer>
        </Modal>

        {/*Camera Number Modal*/}

        <Modal show={showCam_num} onHide={() => setShowCam_num(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Camera Number</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="my-2">
              <Col md={8} >
                Total Number Of Cameras :
              </Col>
              <Col md={4} >
                <div
                  className="d-flex align-items-end justify-content-end"

                >
                  <Button variant="dark" onClick={handleCameraIncre}>
                    +
                  </Button>
                  <h6 className="mx-3"> {countCamera.totalCamera}</h6>
                  <Button variant="dark" onClick={handleCameraDecre}>
                    -
                  </Button>
                </div>
              </Col>

              <Row className="mt-3 p-0" >
                <Col md={4}></Col>
                <Col
                  md={8}
                  className="d-flex justify-content-end p-0 "

                >
                  {" "}
                  <Button
                    onClick={handleCameraIncreByFive}
                    className="mx-3"
                    variant="dark"
                  >
                    Add +5
                  </Button>
                  <Button onClick={handleCameraIncreByTen} variant="dark">
                    Add +10
                  </Button>
                  {/* <Button onClick={deleteCameraIncreByTen} variant="dark">Delete -10</Button> */}
                </Col>
              </Row>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button className="d-block" variant="dark" onClick={handleNext}>
              Next
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Options Modal-2 */}
        <Modal size="lg" show={show2} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Options-X/X</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col className="">
                  <p>Number of Building </p>
                </Col>
                <Col className="d-flex justify-content-end">
                  <p>--</p>
                </Col>
              </Row>

              <Row>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col md={6} className="my-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Building 1/X Name :</Form.Label>
                        <Form.Control
                          type="text"
                          name="building_A_Name"
                          placeholder="Enter Building Name"
                          value={formik.values.building_A_Name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.building_A_Name &&
                          formik.errors.building_A_Name && (
                            <div className="text-danger">
                              {formik.errors.building_A_Name}
                            </div>
                          )}
                      </Form.Group>
                    </Col>
                    <Col md={6} className="my-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label> Cameras Number :</Form.Label>
                        <Form.Control
                          type="number"
                          name="building_A_CameraNumber"
                          placeholder="Enter Camera Number"
                          value={formik.values.building_A_CameraNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.building_A_CameraNumber &&
                          formik.errors.building_A_CameraNumber && (
                            <div className="text-danger">
                              {formik.errors.building_A_CameraNumber}
                            </div>
                          )}
                      </Form.Group>
                    </Col>
                    {/* 2nd Building Info */}
                    <Col md={6} className="my-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Building 2/X Name :</Form.Label>
                        <Form.Control
                          type="text"
                          name="building_B_Name"
                          placeholder="Enter Building Name"
                          value={formik.values.building_B_Name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.building_B_Name &&
                          formik.errors.building_B_Name && (
                            <div className="text-danger">
                              {formik.errors.building_B_Name}
                            </div>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={6} className="my-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label> Cameras Number :</Form.Label>
                        <Form.Control
                          type="number"
                          name="building_B_CameraNumber"
                          placeholder="Enter Camera Number"
                          value={formik.values.building_B_CameraNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.building_B_CameraNumber &&
                          formik.errors.building_B_CameraNumber && (
                            <div className="text-danger">
                              {formik.errors.building_B_CameraNumber}
                            </div>
                          )}
                      </Form.Group>
                    </Col>
                  </Row>{" "}
                  {/* Second - 2 */}
                  <Col className="d-flex justify-content-between">
                    <Button
                      type="submit"
                      variant="danger"
                      onClick={handleClose}
                      className="m-auto my-3"
                    >
                      Next
                    </Button>
                  </Col>
                </Form>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
}

export default Home;
